import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
export default class DeluxePlayerMiniPlayerComponent extends Component {
  @tracked dimensions = {}
  @tracked sizing = {}
  @action
  onContainerSizeChange({ queryResults, dimensions }) {
    this.sizing = queryResults;
    this.dimensions = dimensions;
  }
}
